module.exports = __webpack_public_path__ + "static/media/map.abf14475.png";